

exports.__esModule = true;
exports.$xoBackupLabel = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoBackupLabel = exports.$xoBackupLabel = _squid.$Component.extend('$xoBackupLabel', {
    tag: 'xo-backup-label',
    template: _template2['default'],
    props: {
        plan: {
            type: 'var',
            required: false
        },
        hasMask: {
            type: 'var',
            required: false
        }
    }
});

angular.value("$xoBackupLabel", $xoBackupLabel);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/backup-label/directive.js
// module id = ../node_modules/xo-member-components/src/backup-label/directive.js
// module chunks = 0